



















































































































import { timeDistanceFromNow } from '~/utils/date'
import { defineComponent, ref, computed, watch } from '~/utils/nuxt3-migration'
import { ciEdit } from '~/icons/source/solid/edit'
import { ciTop } from '~/icons/source/solid/top'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { debounce } from '~/utils/function'
import { DEBOUNCE_DEFAULT, DEBOUNCE_SLOW } from '~/constants/debounce'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { formatNumber } from '~/utils/number'
import { useNamespacedStore } from '~/compositions/store'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'

export default defineComponent({
  props: facetHandlerComponentProps,
  setup(props) {
    const { state: classifiedSearchState } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const { changeParam, changeParams } = useClassifiedSearchFacet({
      onClearAll: () => {
        q.value = ''
        minDocCount.value = 1
        selectedValues.value = []
        reverse.value = false
      }
    })

    const q = ref(props.selected.query || '')
    const selectedValues = ref(props.selected.values || [])
    const size = ref(props.selected.size)
    const minDocCount = ref(props.selected.min_doc_count || 1)
    const reverse = ref(props.selected.reverse || false)

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    watch(
      () => props.selected,
      newSelected => {
        q.value = newSelected.query || ''
        selectedValues.value = newSelected.values || []
        size.value = newSelected.size
        minDocCount.value = newSelected.min_doc_count || 1
        reverse.value = newSelected.reverse || false
      }
    )

    const onSearchQueryChange = debounce((text: string) => {
      q.value = text
      emitValues()
    }, DEBOUNCE_DEFAULT)

    const onMinDocCountChange = debounce((text: string) => {
      changeParam({
        name: `${props.name}-m`,
        value: text
      })
    }, DEBOUNCE_SLOW)

    function emitValues() {
      changeParams([
        { name: `${props.name}-q`, value: q.value },
        { name: `${props.name}-s`, value: size.value },
        {
          name: `${props.name}-m`,
          value: minDocCount.value
        },
        {
          name: `${props.name}-r`,
          value: reverse.value
        },
        { name: props.name, value: selectedValues.value }
      ])
    }

    function onClearButtonClick() {
      q.value = ''
      minDocCount.value = 1
      selectedValues.value = []
      reverse.value = false
      emitValues()
    }

    function onSelectedValueChange() {
      q.value = ''
      emitValues()
    }

    function toggleReverse() {
      reverse.value = !reverse.value

      changeParam({
        name: `${props.name}-r`,
        value: reverse.value
      })
    }

    function requestMore() {
      size.value += 100
      emitValues()
    }

    return {
      ciEdit,
      ciTop,
      q,
      loadingFacets,
      selectedValues,
      size,
      minDocCount,
      reverse,
      onSearchQueryChange,
      onMinDocCountChange,
      formatNumber,
      toggleReverse,
      timeDistanceFromNow,
      onClearButtonClick,
      onSelectedValueChange,
      requestMore
    }
  }
})
